
import React from 'react';
import BV from '../../assets/images/bassin-versant.png';
import city from '../../assets/images/chateau.png';
import river from '../../assets/images/mer.png';
import reg from '../../assets/images/region.png';
import dept from '../../assets/images/zone.png';
import { MdAddChart } from 'react-icons/md';
import { Divider } from 'antd';
import { TbChartBarOff } from 'react-icons/tb';

const InfosStation = ({ selectedStation, setShowCompareStation, showCompareStation, compareChartOptions, selectedCompareStation, handleDeleteComparechart }) => {
    return (
        <article className="chart-card">
          <h2>Infos Station</h2>
          <MdAddChart className={showCompareStation ? "picto-desactivated" : "picto-add-chart"} color={showCompareStation ? '#ddd' : 'purple'} size={32} title="Ajouter une station pour comparer" onClick={() => !showCompareStation && setShowCompareStation(!showCompareStation)} />
          <ul className="info-station-list">
            <li>
              <img className='picto' src={city} width={28} alt="ville" />
              <span>{selectedStation?.commune}</span>
            </li>
            <li>
            <img className='picto'  src={dept} width={28} alt="Département" />
              <span>{selectedStation?.dept} - </span>
              <span>{selectedStation?.deptName}</span>
            </li>
            <li>
            <img className='picto'  src={reg} width={28} alt="Région" />
              <span>{selectedStation?.regName}</span>
            </li>
            <li className='infoStation-item'>
            <img className='picto'  src={BV} width={28} alt="Bassin versant" />
              <span className='ellipsis'>{selectedStation?.bvName}</span>
            </li>
            <li>
            <img className='picto'  src={river} width={28} alt="Rivère" />
              <span>{selectedStation?.river}</span>
            </li>
          </ul>
          {showCompareStation && (
            <>
              <Divider />
              <TbChartBarOff className="picto-remove-station" size={32} color="dodgerblue" onClick={handleDeleteComparechart} />
              <ul className="info-station-list">
              <li>
                <img className='picto' src={city} width={28} alt="ville" />
                <span>{selectedCompareStation?.commune}</span>
              </li>
              <li>
              <img className='picto'  src={dept} width={28} alt="Département" />
                <span>{selectedCompareStation?.dept} - </span>
                <span>{selectedCompareStation?.deptName}</span>
              </li>
              <li>
              <img className='picto'  src={reg} width={28} alt="Région" />
                <span>{selectedCompareStation?.regName}</span>
              </li>
              <li>
              <img className='picto'  src={BV} width={28} alt="Bassin versant" />
                <span>{selectedCompareStation?.bvName}</span>
              </li>
              <li>
              <img className='picto'  src={river} width={28} alt="Rivère" />
                <span>{selectedCompareStation?.river}</span>
              </li>
            </ul>
            </>
          )}
        </article>
    );
}

export default InfosStation;